// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Openlayers fixes */

.ol-control {
    clear: both;
    pointer-events: auto;
}

.ol-control button {
    border-radius: inherit;
    color: inherit;
}

.mapadapter-control-container .ol-control {
    position: relative;
    top: inherit;
    right: inherit;
    bottom: inherit;
    left: inherit;
}

.mapadapter-control-container .ol-attribution {
    right: inherit;
    bottom: inherit;
    margin: 0 !important;
    background-color: rgba(255, 255, 255, 0.5);
    padding: 0;
    max-width: 100%;
    white-space: nowrap;
}

.mapadapter-control-container .ol-attribution.ol-uncollapsible {
    right: inherit;
    bottom: inherit;
}

.mapadapter-ctrl-left .openlayers-ctrl .mapadapter-ctrl {
    height: 100%;
}
`, "",{"version":3,"sources":["webpack://./package/nextgisweb/nextgisweb/webmap/nodepkg/ol/panel-control/PanelControl.css"],"names":[],"mappings":"AAAA,qBAAqB;;AAErB;IACI,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,sBAAsB;IACtB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,oBAAoB;IACpB,0CAA0C;IAC1C,UAAU;IACV,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,YAAY;AAChB","sourcesContent":["/* Openlayers fixes */\n\n.ol-control {\n    clear: both;\n    pointer-events: auto;\n}\n\n.ol-control button {\n    border-radius: inherit;\n    color: inherit;\n}\n\n.mapadapter-control-container .ol-control {\n    position: relative;\n    top: inherit;\n    right: inherit;\n    bottom: inherit;\n    left: inherit;\n}\n\n.mapadapter-control-container .ol-attribution {\n    right: inherit;\n    bottom: inherit;\n    margin: 0 !important;\n    background-color: rgba(255, 255, 255, 0.5);\n    padding: 0;\n    max-width: 100%;\n    white-space: nowrap;\n}\n\n.mapadapter-control-container .ol-attribution.ol-uncollapsible {\n    right: inherit;\n    bottom: inherit;\n}\n\n.mapadapter-ctrl-left .openlayers-ctrl .mapadapter-ctrl {\n    height: 100%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
